export const insertPicturesInlineTooltip = "Yqc";
export default {insertPicturesInlineTooltip};